import { regionLangMap } from '../share';

export type FormValues = Partial<Omit<Aide.WhatsAppTemplateGroup, 'template'>> &
  Partial<Pick<Aide.WhatsAppTemplate, 'wabaId' | 'category'>> & {
    regionTemplateMap: Partial<
      Record<
        Aide.WhatsAppRegion,
        Partial<
          Omit<
            Aide.WhatsAppTemplate,
            'lang' | 'name' | 'wabaId' | 'phone' | 'category' | 'group' | 'status' | 'show'
          > & { cancelled?: boolean }
        >
      >
    >;
  };

export type FV = FormValues;

const languageFooterMap: Record<Aide.WhatsAppLanguage, string> = {
  zh_CN: '如果您不想收到后续消息，请回复“Reject”',
  fil: `Kung ayaw maka-receive ng message pwede i-click ang 'Reject'`,
  th: `หากคุณไม่ต้องการรับข้อความอีก โปรดตอบกลับ ’Reject‘`,
  ms: `Jika anda tidak mahu menerima mesej, sila balas 'Reject'.`,
  pt_BR: `Se você não quiser receber mensagens, responda 'Reject'.`,
  id: `Jika tidak ingin menerima pesan lagi, harap balas 'Reject'.`,
  vi: `Nếu không muốn nhận tin nhắn, vui lòng trả lời 'Reject'.`,
  en: `To stop receiving messages, reply 'Reject'.`,
  es_MX: `Si no desea recibir mensajes seguidos, responda 'Reject'.`,
};

export const getDefaultTemplate = (
  lang: Aide.WhatsAppLanguage,
): Required<FV['regionTemplateMap']>['CN'] => {
  return {
    footer: languageFooterMap[lang],
    header: undefined,
    content: [],
    translateContent: [],
    buttons: [],
  };
};

export const defaultInitialValues: FV = {
  name: '',
  wabaId: undefined,
  category: undefined,
  group: undefined,
  regionTemplateMap: Object.keys(regionLangMap).reduce<FV['regionTemplateMap']>((res, region) => {
    res[region] = getDefaultTemplate(regionLangMap[region]);
    return res;
  }, {}),
};
